<template>
    <div class="exception-body error">
        <img v-if="showLogo" src="layout/images/logo-white.svg" alt="diamond-layout" class="logo" />

        <div class="exception-content">
            <div class="exception-title">ERRORE</div>
            <div class="exception-detail">Qualcosa è andato storto</div>
            <a v-if="reloadButton" href="javascript:location.reload();">Ricarica la pagina</a>
            <router-link v-else to="/">Torna alla Dashboard</router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showLogo: {
            type: Boolean,
            required: false,
            default: true
        },
        reloadButton: {
            type: Boolean,
            required: false,
            default: true
        }
    }
};
</script>